<nav class="navbar navbar--central fixed-top">
  <!-- Logo in nav bar -->
  <div class="container-fluid">
    <div class="navbar-policy">
      <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
        <a>Account</a>
        <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
        <a>{{activeRoute?.replace('-',' ') | titlecase}}</a>
      </div>

      <a href="#modal-submenu" data-toggle="modal" class="navbar-policy__submenu d-lg-none">
        <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
      </a>

      <div class="navbar-policy__nav d-lg-none">
        <div class="navbar-policy__nav-current"><strong>Your Account</strong></div>
      </div>

      <a href="javascript:void(0);" [routerLink]="['/'+documentPageRoute]" class="navbar-policy__close">
        <svg class="icon"><use xlink:href="#close-medium"></use></svg>
      </a>
    </div>
  </div>
</nav>

<main class="page-main">
  <div class="container layout layout--modal">

    <div class="layout__row">
      <div class="layout__sidecol">
        <div class="layout__sidecolinner">
          <div class="card card--menu">

            <div class="card-body position-relative">
              <div class="menu-sections">
                <div class="menu-sections__section">
                  <div class="menu-sections__title">
                    <small>Account</small>
                  </div>

                  <div class="menu-sections__item">
                    <a href="javascript:void(0);"
                      class="menu-sections__item-title"
                      [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.ChangePassword]"
                      [ngClass]="{' is-active' :  activeRoute === routerLinks.ChangePassword}">
                      <div class="menu-sections__item-text">
                        <h4>Change Password</h4>
                      </div>
                      <div class="menu-sections__item-caret">
                        <svg class="icon">
                          <use xlink:href="#chevron-right-small"></use>
                        </svg>
                      </div>
                    </a>
                  </div>
                  @if (false) {
                    <div class="menu-sections__item">
                      <a href="javascript:void(0);"
                        class="menu-sections__item-title"
                        [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.NotificationSettings]"
                        [ngClass]="{' is-active' :  activeRoute === routerLinks.NotificationSettings}">
                        <div class="menu-sections__item-text">
                          <h4>Notification Settings</h4>
                        </div>
                        <div class="menu-sections__item-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-right-small"></use>
                          </svg>
                        </div>
                      </a>
                    </div>
                  }

                  <div class="menu-sections__item">
                    <a href="javascript:void(0);"
                      class="menu-sections__item-title"
                      [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.PaymentDetails]"
                      [ngClass]="{' is-active' :  activeRoute === routerLinks.PaymentDetails}">
                      <div class="menu-sections__item-text">
                        <h4>Payment Details</h4>
                      </div>
                      <div class="menu-sections__item-caret">
                        <svg class="icon">
                          <use xlink:href="#chevron-right-small"></use>
                        </svg>
                      </div>
                    </a>
                  </div>

                  <!-- <div *ngIf="user.broker_id === 0 && !user.console_access" class="menu-sections__item">
                  <a href="javascript:void(0);" class="menu-sections__item-title"
                    [routerLink]="['/' + routerLinks.Referrals]"
                    [ngClass]="{' is-active' :  activeRoute === routerLinks.Referrals}"
                    >
                    <div class="menu-sections__item-text">
                      <h4>Referrals</h4>
                    </div>
                    <div class="menu-sections__item-caret">
                      <svg class="icon">
                        <use xlink:href="#chevron-right-small"></use>
                      </svg>
                    </div>
                  </a>
                </div> -->

                <!-- <div *ngIf="user.broker_id === 0 && !user.console_access"  class="menu-sections__item">
                <a href="javascript:void(0);" class="menu-sections__item-title"
                  [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.Wallet]"
                  [ngClass]="{' is-active' :  activeRoute === routerLinks.Wallet}"
                  >
                  <div class="menu-sections__item-text">
                    <h4>Wallet</h4>
                  </div>
                  <div class="menu-sections__item-caret">
                    <svg class="icon">
                      <use xlink:href="#chevron-right-small"></use>
                    </svg>
                  </div>
                </a>
              </div> -->

              <!--<div class="menu-sections__item">
              <a href="javascript:void(0);" class="menu-sections__item-title">
                <div class="menu-sections__item-text">
                  <h4>Better Deal Alerts</h4>
                </div>
                <div class="menu-sections__item-caret">
                  <svg class="icon">
                    <use xlink:href="#chevron-right-small"></use>
                  </svg>
                </div>
              </a>
            </div>-->
          </div>

          <!--<div class="menu-sections__section">
          <div class="menu-sections__title">
            <small>Legal</small>
          </div>

          <div class="menu-sections__item">
            <a href="javascript:void(0);" class="menu-sections__item-title">
              <div class="menu-sections__item-text">
                <h4>Privacy Policy</h4>
              </div>
              <div class="menu-sections__item-caret">
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
            </a>
          </div>

          <div class="menu-sections__item">
            <a href="javascript:void(0);" class="menu-sections__item-title">
              <div class="menu-sections__item-text">
                <h4>Terms of Use</h4>
              </div>
              <div class="menu-sections__item-caret">
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
            </a>
          </div>

          <div class="menu-sections__item">
            <a href="javascript:void(0);" class="menu-sections__item-title">
              <div class="menu-sections__item-text">
                <h4>Fees</h4>
              </div>
              <div class="menu-sections__item-caret">
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
            </a>
          </div>
        </div>-->


        <div class="menu-sections__section">
          <div class="menu-sections__item">
            <a href="javascript:void(0);" (click)="logout()" class="menu-sections__item-title">
              <div class="menu-sections__item-text">
                <svg class="icon icon--flip">
                  <use xlink:href="#login"></use>
                </svg>
                <h4>Log Out</h4>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</div>

<div class="layout__main">
  <div class="card card--edit">
    <div class="card-body">
      <div class="card__content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</main>

<div class="disclaimer">
  <small>
    EIDI is a licensed financial services provider with FSP 21271.
  </small>
</div>

@if (showAccountPagesSaveCloseTray) {
  <footer class="question-tray">
    <div class="container">
      <div class="question-tray__controls">
        <div class="question-tray__btns">
          <a href="javascript:void(0);" [routerLink]="['/' + routerLinks.DashboardLanding]" class="button button--lg button--secondary">Cancel</a>
          <a href="javascript:void(0);" [attr.disabled]="buttonDisabled ? buttonDisabled : null" (click)="save()" class="button button--lg button--primary"> Save </a>
        </div>
      </div>
    </div>
  </footer>
}


<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-submenu" tabindex="-1" role="dialog" aria-labelledby="modal-submenu"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">
      <div class="modal-traymenu__header modal-traymenu__header--no-bdr">
        <div class="container">
          <a href="#" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__content pt-0">

        <div class="container">
          <!-- identical to desktop version -->
          <div class="menu-sections">
            <div class="menu-sections__section">
              <div class="menu-sections__title">
                <small>Account</small>
              </div>

              <div class="menu-sections__item">
                <a href="javascript:void(0);"
                  class="menu-sections__item-title"
                  data-dismiss="modal"
                  [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.ChangePassword]"
                  [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                  <div class="menu-sections__item-text">
                    <h4>Change Password</h4>
                  </div>
                  <div class="menu-sections__item-caret">
                    <svg class="icon">
                      <use xlink:href="#chevron-right-small"></use>
                    </svg>
                  </div>
                </a>
              </div>

              @if (false) {
                <div class="menu-sections__item">
                  <!-- <div *ngIf="user.broker_id === 0 && !user.console_access" class="menu-sections__item"> -->
                  <a href="javascript:void(0);"
                    class="menu-sections__item-title"
                    data-dismiss="modal"
                    [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.NotificationSettings]"
                    [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                    <div class="menu-sections__item-text">
                      <h4>Notification Settings</h4>
                    </div>
                    <div class="menu-sections__item-caret">
                      <svg class="icon">
                        <use xlink:href="#chevron-right-small"></use>
                      </svg>
                    </div>
                  </a>
                </div>
              }

              @if (user.broker_id === 0 && !user.console_access) {
                <div class="menu-sections__item">
                  <a href="javascript:void(0);"
                    class="menu-sections__item-title"
                    data-dismiss="modal"
                    [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.PaymentDetails]"
                    [ngClass]="{' is-active' :  activeRoute === routerLinks.PaymentDetails}">
                    <div class="menu-sections__item-text">
                      <h4>Payment Details</h4>
                    </div>
                    <div class="menu-sections__item-caret">
                      <svg class="icon">
                        <use xlink:href="#chevron-right-small"></use>
                      </svg>
                    </div>
                  </a>
                </div>
              }

              <div class="menu-sections__item">
                <a href="javascript:void(0);" class="menu-sections__item-title"
                  data-dismiss="modal"
                  [routerLink]="['/' + routerLinks.Account + '/' + routerLinks.Referrals]"
                  [ngClass]="{' is-active' :  activeRoute === routerLinks.Referrals}">
                  <div class="menu-sections__item-text">
                    <h4>Referrals</h4>
                  </div>
                  <div class="menu-sections__item-caret">
                    <svg class="icon">
                      <use xlink:href="#chevron-right-small"></use>
                    </svg>
                  </div>
                </a>
              </div>

              <!-- <div class="menu-sections__item">
              <a href="javascript:void(0);" class="menu-sections__item-title">
                <div class="menu-sections__item-text">
                  <h4>Wallet</h4>
                </div>
                <div class="menu-sections__item-caret">
                  <svg class="icon">
                    <use xlink:href="#chevron-right-small"></use>
                  </svg>
                </div>
              </a>
            </div> -->

            <!--<div class="menu-sections__item">
            <a href="javascript:void(0);" class="menu-sections__item-title">
              <div class="menu-sections__item-text">
                <h4>Better Deal Alerts</h4>
              </div>
              <div class="menu-sections__item-caret">
                <svg class="icon">
                  <use xlink:href="#chevron-right-small"></use>
                </svg>
              </div>
            </a>
          </div>-->
        </div>


        <!--<div class="menu-sections__section">
        <div class="menu-sections__title">
          <small>Legal</small>
        </div>

        <div class="menu-sections__item">
          <a href="javascript:void(0);" class="menu-sections__item-title">
            <div class="menu-sections__item-text">
              <h4>Privacy Policy</h4>
            </div>
            <div class="menu-sections__item-caret">
              <svg class="icon">
                <use xlink:href="#chevron-right-small"></use>
              </svg>
            </div>
          </a>
        </div>

        <div class="menu-sections__item">
          <a href="javascript:void(0);" class="menu-sections__item-title">
            <div class="menu-sections__item-text">
              <h4>Terms of Use</h4>
            </div>
            <div class="menu-sections__item-caret">
              <svg class="icon">
                <use xlink:href="#chevron-right-small"></use>
              </svg>
            </div>
          </a>
        </div>

        <div class="menu-sections__item">
          <a href="javascript:void(0);" class="menu-sections__item-title">
            <div class="menu-sections__item-text">
              <h4>Fees</h4>
            </div>
            <div class="menu-sections__item-caret">
              <svg class="icon">
                <use xlink:href="#chevron-right-small"></use>
              </svg>
            </div>
          </a>
        </div>
      </div>-->
      @if (isBiometrics) {
        <div class="menu-sections__section">
          <div class="menu-sections__item">
            <label class="custom-toggle custom-toggle--lg custom-toggle--inline">
              <input type="checkbox" [checked]="useBiometrics?.useBiometrics" (change)="setBiometrics()" name="add-note-toggle" id="faceid">
              <span class="custom-toggle__indi"></span>
              <span class="custom-toggle__label">Use Face ID</span>
            </label>
          </div>
        </div>
      }
      <div class="menu-sections__section">

        <div class="menu-sections__item">
          <a href="javascript:void(0);" data-dismiss="modal" (click)="logout()" class="menu-sections__item-title">
            <div class="menu-sections__item-text">
              <svg class="icon icon--flip">
                <use xlink:href="#login"></use>
              </svg>
              <h4>Log Out</h4>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
<!-- /modal -->
